import React, { useState, useEffect } from "react";
import { ChevronRight, X, UserPlus } from "lucide-react";
import MobileReferenceModal from "../../approval/MobileReferenceModal";

export default function MobilePeopleCell({
  value = [],
  onChange,
  placeholder = "담당자를 선택하세요",
}) {
  const [open, setOpen] = useState(false);
  const [tempSelectedIds, setTempSelectedIds] = useState([]);

  useEffect(() => {
    if (open) {
      setTempSelectedIds(value.map((v) => v.id));
    }
  }, [open, value]);

  const handleSave = (ids, userDetails) => {
    const mapped = userDetails.map((u) => ({
      id: u.id,
      name: u.name ?? `${u.last_name ?? ""}${u.first_name ?? ""}`,
    }));
    onChange(mapped);
    setOpen(false);
    return true;
  };

  const removePerson = (e, id) => {
    e.stopPropagation();
    const nextValue = value.filter((p) => p.id !== id);
    onChange(nextValue);
    setTempSelectedIds(nextValue.map(p => p.id));
  };

  return (
    <div className="w-full">
      {/* 선택된 담당자 목록 */}
      {value.length > 0 && (
        <div className="flex flex-wrap gap-2 mb-3">
          {value.map((p) => (
            <span
              key={p.id}
              className="inline-flex items-center gap-1.5 px-3 py-1.5 text-[13px] font-medium bg-blue-50 text-blue-700 rounded-full border border-blue-200"
            >
              {p.name || p.user?.name}
              <button
                onClick={(e) => removePerson(e, p.id)}
                className="w-4 h-4 flex items-center justify-center rounded-full bg-blue-200 hover:bg-blue-300 transition-colors"
              >
                <X size={10} strokeWidth={3} />
              </button>
            </span>
          ))}
        </div>
      )}

      {/* 담당자 선택 버튼 */}
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="w-full flex items-center justify-between px-4 py-3 rounded-xl border border-gray-200 bg-white hover:bg-gray-50 active:scale-[0.99] transition-all"
      >
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-full bg-slate-100 flex items-center justify-center">
            <UserPlus size={18} className="text-slate-500" />
          </div>
          <div className="text-left">
            {value.length > 0 ? (
              <>
                <p className="text-[13px] font-medium text-slate-800">
                  {value.length}명 선택됨
                </p>
                <p className="text-[11px] text-slate-400">
                  탭하여 수정
                </p>
              </>
            ) : (
              <>
                <p className="text-[13px] font-medium text-slate-500">
                  {placeholder}
                </p>
                <p className="text-[11px] text-slate-400">
                  탭하여 선택
                </p>
              </>
            )}
          </div>
        </div>
        <ChevronRight size={18} className="text-slate-400" />
      </button>

      <MobileReferenceModal
        isOpen={open}
        onClose={() => setOpen(false)}
        selectedIds={tempSelectedIds}
        name="담당자"
        onChange={(ids) => setTempSelectedIds(ids)}
        onSave={handleSave}
      />
    </div>
  );
}
